import { useMemo, useState } from 'react'
import { useMediaQuery } from '@mui/material'
import { ChartData, CustomLabelI, SnowflakeChartData } from 'models'
import { initialValues, INITIALIZING_TIMER, FormValues } from '../../../library/library.constants'
import { formatCpiUrlToName } from 'lib/utils'

interface Props {
  cpiName: string | undefined
}

const useLibraryDetailsState = ({ cpiName }: Props) => {
  const isMediumHeight = useMediaQuery('(max-height:900px)')
  const thisCpiName = useMemo(() => formatCpiUrlToName(cpiName || ''), [cpiName])
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [labelDrawerOpen, setLabelDrawerOpen] = useState(false)
  const [renderingChart, setRenderingChart] = useState(true)
  const [isExportingReport, setIsExportingReport] = useState(false)
  const [showMessage, setShowMessage] = useState(false)
  const [recalculatingCpiName, setRecalculatingCpiName] = useState<string | null>(null)
  const [defaultRecentValueDate, setDefaultRecentValueDate] = useState({
    date: '',
    value: '',
    denominator: '0',
    lastValue: ''
  })
  const [recentInitialLoad, setRecentInitialLoad] = useState(false)

  const [chartData, setChartData] = useState<ChartData | SnowflakeChartData | null>(null)
  const [defaultValues, setDefaultValues] = useState<FormValues>(initialValues)
  const [criticalSla, setCriticalSla] = useState<number | undefined>(undefined)
  const [fetchingInterval, setFetchingInterval] = useState(INITIALIZING_TIMER)
  const [healthDirection, setHealthDirection] = useState('')
  const [currentSeverityStatus, setCurrentSeverityStatus] = useState<'healthy' | 'problematic'>('healthy')
  const [code, setCode] = useState('')

  const [emptyInfoTooltipOpen, setEmptyInfoTooltipOpen] = useState(false)
  const [slaDescriptionTooltipOpen, setSlaDescriptionTooltipOpen] = useState(false)
  const [mode, setMode] = useState('create')
  const [editLabel, setEditLabel] = useState({} as CustomLabelI)
  const [redirectToMode, setRedirectToMode] = useState('show-0')

  const handleEmptyInfoClick = () => {
    setEmptyInfoTooltipOpen(!emptyInfoTooltipOpen)
  }

  const handleSlaDescriptionTooltipClick = () => {
    setSlaDescriptionTooltipOpen(!slaDescriptionTooltipOpen)
  }

  return {
    drawerOpen,
    setDrawerOpen,
    labelDrawerOpen,
    setLabelDrawerOpen,
    renderingChart,
    setRenderingChart,
    isExportingReport,
    setIsExportingReport,
    showMessage,
    setShowMessage,
    recalculatingCpiName,
    setRecalculatingCpiName,
    chartData,
    setChartData,
    defaultValues,
    setDefaultValues,
    criticalSla,
    setCriticalSla,
    fetchingInterval,
    setFetchingInterval,
    healthDirection,
    setHealthDirection,
    currentSeverityStatus,
    setCurrentSeverityStatus,
    code,
    setCode,
    emptyInfoTooltipOpen,
    setEmptyInfoTooltipOpen,
    slaDescriptionTooltipOpen,
    setSlaDescriptionTooltipOpen,
    mode,
    setMode,
    redirectToMode,
    setRedirectToMode,
    handleEmptyInfoClick,
    handleSlaDescriptionTooltipClick,
    isMediumHeight,
    thisCpiName,
    defaultRecentValueDate,
    setDefaultRecentValueDate,
    recentInitialLoad,
    setRecentInitialLoad,
    editLabel,
    setEditLabel
  }
}

export default useLibraryDetailsState
